module.exports = __webpack_public_path__ + "a2b78d9bb8a658d86b505607e19043a0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../components/profile-pic.jpg
 ** module id = 1391
 ** module chunks = 0
 **/